import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RowSelectedEvent } from 'ag-grid-enterprise';
import { ProposalRequestForm } from 'src/app/classes/form-groups/proposal-request-form';
import { Site } from 'src/app/classes/models';
import { GenericObject } from 'src/app/interfaces/generic-object';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-quicksource-site-selection',
  templateUrl: './quicksource-site-selection.component.html',
  styleUrls: ['./quicksource-site-selection.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class QuicksourceSiteSelectionComponent implements OnInit {
  private _cdr = inject(ChangeDetectorRef);

  constructor(
    private ToastService: ToastService,
    private SharedDataService: SharedDataService,
    private route: ActivatedRoute
  ) {
    this.SharedDataService.listenForEvent<
      ProposalRequestForm | boolean
    >().subscribe({
      next: ({ eventName, data }) => {
        if (
          eventName === 'SetProposalRequestForm' &&
          typeof data !== 'boolean'
        ) {
          this.ProposalRequestFormGroup = data;

          if (this.ProposalRequestFormGroup) {
            const { SiteId } = this.ProposalRequestFormGroup.value;
            if (SiteId) {
              this.selectedRowsPrimaryKeys.add(SiteId);
            }
          }
          this._cdr.markForCheck();
        }

        if (eventName === 'SetDisableInput' && typeof data === 'boolean') {
          this.disableInput = data;
          this._cdr.markForCheck();
        }
      }
    });
    this.SharedDataService.sendEvent('GetProposalRequestForm');
    this.SharedDataService.sendEvent('GetDisableInput');

    this.route.paramMap.subscribe({
      next: (ParamMap) => {
        const SiteId = Number(ParamMap.get('SiteId'));

        if (SiteId) {
          this.selectedRowsPrimaryKeys.add(SiteId);
          this._cdr.markForCheck();
        }
      }
    });
  }

  // This may be reverted and go forward with proposal request address.
  SuppliedSiteQueryData: GenericObject = {
    StreetAddress: {
      options: { required: false },
      attributes: ['id', 'address1', 'city', 'state', 'zip']
    }
  };

  ProposalRequestFormGroup?: ProposalRequestForm;
  selectedRowsPrimaryKeys: Set<string | number> = new Set();
  disableInput?: boolean;
  showGrid: boolean = false;

  setSiteId(selectedRow: RowSelectedEvent) {
    if (!this.ProposalRequestFormGroup) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Proposal Form has not been set.',
        { returnError: true }
      );
    }

    const { node } = selectedRow;
    const { data } = node;
    const { id: SiteId, legalName } = data;

    if (!SiteId) {
      throw this.ToastService.addErrorToast('Error', 'Site is missing id.', {
        returnError: true
      });
    }

    // Only handle selected node.
    if (node.isSelected()) {
      this.ProposalRequestFormGroup.patchValue({
        SiteId,
        Site: { id: SiteId, legalName }
      });
      this.ProposalRequestFormGroup.controls['Address'].patchValue({
        address1: data?.StreetAddress?.address1 || undefined,
        address2: data.StreetAddress?.address2,
        state: data.StreetAddress?.state,
        city: data?.StreetAddress?.city || undefined,
        zip: data?.StreetAddress?.zip || undefined
      });
      this.SharedDataService.sendEvent('SiteSelected', new Site(data));
      this._cdr.markForCheck();
    }
  }

  ngOnInit(): void {}
}
